import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=d881be24&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"
import style0 from "./Comments.vue?vue&type=style&index=0&id=d881be24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d881be24",
  null
  
)

export default component.exports